
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";
import { RegisterMode, ClearCardRegistered } from "../../../actions/terminal";
import { createSelector } from "reselect";

class DmsRegister extends Component {
    constructor (props) {
        super(props);
        this.registerPopupForDms = this.registerPopupForDms.bind(this);
    }

    registerPopupForDms () {
        return () => {
            this.props.closePopup()();
            this.props.dispatch(RegisterMode(false));
            this.props.dispatch(ClearCardRegistered());
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.isAdminLoggedIn,
            state => state.terminal.isCardRegistered
        ],
        (isAdminLoggedIn, isCardRegistered) => {
            return {isAdminLoggedIn, isCardRegistered};
        }
    );
};

DmsRegister.propTypes = {
    closePopup: PropTypes.func,
    isCardRegistered: PropTypes.func
};

export default connect(mapStateToProps)(UIMixin({Component: DmsRegister}));